import { truMetriXService, Event, Environment, EnvTags, TruMetriXService } from "./services/trumetrix.service.js";

export { 
	truMetriXService, 
	Event,
	Environment,
	EnvTags,
	TruMetriXService
};